import { useEffect, useRef } from 'react';
import Glide from '@glidejs/glide';

import { func, node, shape } from 'prop-types';
import superDestacadoConfig from './config';
import { childrenPropType } from '../../../../../utils';
import '../../../Glide/style.scss';

const WidgetTePuedeInteresar = ({ children, config, widget }) => {
  const glideRef = useRef();

  useEffect(() => {
    try {
      const container = widget.querySelector('.glide');
      if (container) {
        const currentConfig = { ...config };

        const glide = new Glide(container, currentConfig);
        glide.mount();

        glideRef.current = glide;
      }

      return () => {
        if (glideRef.current) {
          glideRef.current.destroy();
        }
      };
    } catch (err) {
      console.log(`Ha ocurrido un error al montar el super destacado `);
    }
    return () => null;
  }, [config, widget]);

  return children;
};

WidgetTePuedeInteresar.propTypes = {
  widget: node.isRequired,
  config: shape({}),
  children: childrenPropType,
  onSlideClick: func
};

WidgetTePuedeInteresar.defaultProps = {
  onSlideClick: null,
  children: null,
  config: superDestacadoConfig
};

export default WidgetTePuedeInteresar;
